module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "Section Section-Title"
  }, [_c('h2', {
    staticClass: "Product-Title test-product_title"
  }, [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _c('p', {
    staticClass: "Product-Price"
  }, [_vm._v("\n            " + _vm._s(_vm._f("formatCurrency")(_vm.base_product_price, _vm.active_module.currency)) + "\n        ")]), _vm._v(" "), (_vm.product.description) ? _c('ul', {
    staticClass: "Description-Nav"
  }, [_c('li', {
    staticClass: "Description-Nav-Item Description-Nav-Item--Active pointer"
  }, [_vm._v(_vm._s(_vm.$t('product.description')))]), _vm._v(" "), _c('li', {
    staticClass: "Description-Nav-Item disabled pointer"
  }, [_vm._v(_vm._s(_vm.$t('product.more_info')))])]) : _vm._e()]), _vm._v(" "), (_vm.product.description) ? _c('div', {
    staticClass: "Section Section--Top-Bordered Section-Description"
  }, [_c('span', {
    staticClass: "Product-Description",
    attrs: {
      "transition": "fade"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.product.modifiers && _vm.product.modifiers.length || _vm.product.price_list) ? _c('div', {
    staticClass: "Section Section--Top-Bordered Section-Modifiers"
  }, [(_vm.product.price_list) ? _c('list-price', {
    attrs: {
      "label": _vm.product.price_list_data.label,
      "values": _vm.product.price_list_data.values,
      "currency": _vm.active_module.currency
    },
    on: {
      "change": _vm.change_price_details
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product.modifiers) ? _c('modifier-list', {
    attrs: {
      "modifiers": _vm.product.modifiers
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Section Section--Top-Bordered Section-AddToCart"
  }, [_c('div', {
    staticClass: "Details-Container Centered"
  }, [(_vm.product.is_disabled == '') ? _c('select', {
    staticClass: "AddToCartQty test-product_quantity_selector",
    on: {
      "change": _vm.update_quantity
    }
  }, _vm._l((100), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  })) : _vm._e(), _vm._v(" "), (_vm.product.is_disabled == '') ? _c('div', [_c('button', {
    staticClass: "AddToCartButton",
    attrs: {
      "id": "test-add_to_cart"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.add_product_to_cart($event)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('product.cta_addtocart', {
    price: ''
  })) + " "), _c('span', {
    staticClass: "AddToCart-Price"
  }, [_vm._v(_vm._s(_vm.active_price_with_currency))])])]) : _vm._e(), _vm._v(" "), (_vm.product.is_disabled === 'x') ? _c('span', {
    staticClass: "Product-Disabled"
  }, [_vm._v(_vm._s(_vm.$t('product.title_closedforsale')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "Section Section-ContinueShopping"
  }, [_c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'List',
          params: {
            module_id: _vm.active_module.module_id,
            scrollParent: true
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cart.cta_goback')))])]), _vm._v(" "), (_vm.product.is_disabled === '') ? _c('div', {
    staticClass: "Section Section--Top-Bordered Section-CartResume"
  }, [(_vm.is_active) ? _c('div', {
    staticClass: "left",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('img', {
    staticClass: "decorator",
    attrs: {
      "height": "35",
      "src": "/static/img/bag_icon.svg",
      "alt": "Bag"
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "#04BE5B"
    }
  }, [_vm._v(_vm._s(_vm.cartItems) + " " + _vm._s(_vm.$tc('cart.item', _vm.cartItems)) + " ")]), (false) ? _c('span', [_vm._v(_vm._s(_vm.$t('cart.in_your_cart')))]) : _vm._e(), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('cart.title_totalamount')) + " " + _vm._s(_vm._f("formatCurrency")(_vm.amount_with_modifiers_normal, _vm.active_module.currency)))])])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active),
      expression: "is_active"
    }],
    staticClass: "cta-cart-button btn btn-default",
    attrs: {
      "type": "button",
      "value": _vm.$t('product.cta_checkoutpage')
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'Checkout',
          params: {
            module_id: _vm.active_module.module_id
          }
        })
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_active),
      expression: "!is_active"
    }],
    staticClass: "Cart-Empty",
    attrs: {
      "id": "test-cart-is-empty-message"
    }
  }, [_vm._v(_vm._s(_vm.$t('cart.warning_empty')))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d85d654!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/_partials/buy-box.vue
// module id = 246
// module chunks = 1